import { FC } from 'react';
import { Box } from '@mui/material';
import { Chart } from './components/chart.component';
import { Loader } from '../../foundation/shared/components/loader';
import { useSymbolFeedContext } from '../layouts/symbol-feed.context';
import { useChartData } from './hooks/chart-data.hook';
import { ChartContextProvider } from './components/chart.context';
import { ChartStreamProvider } from './components/chart-stream.context';
import { useObservable } from '@client/foundation/shared/utils/observable.hook';

export type ChartWidgetProps = { timeframeIndex: number };

const ChartWidgetContent: FC<{
  timeframeIndex: number;
  timeframe?: string;
}> = ({ timeframeIndex, timeframe }) => {
  const { loading$ } = useSymbolFeedContext();
  const loading = useObservable(() => loading$, false);
  const chartData = useChartData();

  return (
    <ChartContextProvider data={chartData}>
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          position: 'relative'
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Box
            sx={{
              textAlign: 'center',
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              position: 'relative'
            }}
          >
            <Chart timeframeIndex={timeframeIndex} timeframe={timeframe} />
            {loading ? <Loader /> : null}
          </Box>
        </Box>
      </Box>
    </ChartContextProvider>
  );
};

export const ChartWidget: FC<ChartWidgetProps> = ({ timeframeIndex }) => {
  const { state: formState } = useSymbolFeedContext();

  if (!formState) return null;

  const timeframe = formState.timeframes?.[timeframeIndex]?.timeframe;

  return (
    <ChartStreamProvider timeframeIndex={timeframeIndex} formState={formState}>
      <ChartWidgetContent
        timeframeIndex={timeframeIndex}
        timeframe={timeframe}
      />
    </ChartStreamProvider>
  );
};
